import request from '@/util/request';
import qs from 'qs';
// 志愿者管理
export const getList = (params, options) =>
request.get('/api/v4ward/community/volunteer/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/community/volunteer/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/community/volunteer/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/community/volunteer/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/community/volunteer/update', params,options)
